import { HiLibrary, HiArrowNarrowLeft, HiCloudUpload } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

const LibraryPageBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[85vh] flex items-center justify-center p-6 bg-slate-50 font-sans">
      <div className="max-w-xl w-full">
        {/* Main Branding Card */}
        <div className="bg-white rounded-[3rem] p-10 md:p-14 shadow-2xl shadow-blue-100 border border-slate-100 text-center relative overflow-hidden">
          
          {/* Subtle Background Glow */}
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-600 via-indigo-500 to-purple-600"></div>
          
          {/* Resource Icon */}
          <div className="relative inline-block mb-10">
            <div className="w-24 h-24 bg-slate-50 text-blue-600 rounded-3xl flex items-center justify-center mx-auto shadow-inner border border-slate-100">
              <HiLibrary size={48} className="animate-pulse" />
            </div>
            {/* Status Badge */}
            <div className="absolute -top-3 -right-3 bg-indigo-600 text-white text-[9px] font-black px-3 py-1 rounded-full shadow-lg uppercase tracking-widest border-4 border-white">
              Storage Sync
            </div>
          </div>

          {/* Headline */}
          <h2 className="text-3xl font-black text-slate-900 uppercase tracking-tighter mb-4 leading-tight">
            Campus <span className="text-blue-600">Library</span>
          </h2>
          
          <p className="text-slate-500 font-medium leading-relaxed mb-10">
            We are currently optimizing our <strong>Cloud Storage</strong> to provide high-speed access to notes, PYQs, and study materials. Access will be restored shortly.
          </p>

          {/* Storage "Loading" Graphic */}
          <div className="bg-slate-50 rounded-2xl p-5 border border-slate-100 mb-10">
            <div className="flex items-center justify-between mb-3 px-1">
              <div className="flex items-center gap-2">
                <HiCloudUpload className="text-blue-600" />
                <span className="text-[10px] font-black uppercase text-slate-400">Server Allocation</span>
              </div>
              <span className="text-[10px] font-black text-blue-600">92%</span>
            </div>
            <div className="w-full h-1.5 bg-slate-200 rounded-full overflow-hidden">
               <div className="h-full bg-blue-600 animate-pulse w-[92%]"></div>
            </div>
          </div>

          {/* Action Button */}
          <button 
            onClick={() => navigate('/')}
            className="w-full bg-slate-900 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-blue-600 transition-all active:scale-95 shadow-lg flex items-center justify-center gap-2"
          >
            <HiArrowNarrowLeft />
            Return to Dashboard
          </button>
        </div>

        {/* Footer Info */}
        <p className="mt-8 text-center text-slate-400 text-[10px] font-bold uppercase tracking-[0.3em]">
          CampusIRA Digital Assets • V2.0 Coming Soon
        </p>
      </div>
    </div>
  );
};

export default LibraryPageBanner;